export const CAROUSEL_DEFAULT_ALT = 'Carousel image';
//# sourceMappingURL=constants.js.map